// Content titles only supplement text that is actually ellipsized in its cell.
export default function updateOverflowTitle(element: HTMLElement, text: string) {
  if (element.scrollWidth > element.clientWidth + 1) element.title = text;
  else element.removeAttribute('title');
}
